import { DatePipe } from "@angular/common";
import { Component, computed, effect, inject, input, signal } from "@angular/core";
import { ThousandizePipe } from "ev-core";
import { BaseListComponent, EvGridTableModule, ITableHeader, ITableLayoutModel } from "ev-grid-table";
import { DefaultConverterPipe } from "src/app/shared/pipes/defaultconverter.pipe";
import { ShareSalesDetailComponent } from "./share-sales-detail.component";
import { ShareSalesDto } from "src/models/estate/share-sales.model";
import { SalesDataService } from "src/services/sales-data.service";
import { ImagePackage } from "src/models/common/image.model";
import { environment } from "src/environments/environment";

@Component({
    selector: "share-sales",
    templateUrl: "./share-sales.component.html",
    styleUrl: "./share-sales.component.scss",
    imports: [EvGridTableModule, DefaultConverterPipe, ThousandizePipe, DatePipe, ShareSalesDetailComponent],
})
export class ShareSalesComponent extends BaseListComponent<ShareSalesDto> {
    private salesDataService = inject(SalesDataService);

    shareSales = input.required<ShareSalesDto[]>();
    unitId = input.required<number>();

    protected imagePackageDictionary = signal<Record<number, ImagePackage[]>>({});
    protected rowData = signal<ShareSalesDto>(null!);

    constructor() {
        super();
        effect((onCleanup) => {
            const data = this.rowData();
            const uid = this.unitId();
            const imagePackageDictionary = this.imagePackageDictionary();
            if (!data || imagePackageDictionary[data.saleId!]) {
                return;
            }

            const sub = this.salesDataService.getSalesImagesResource(uid, data.saleId).subscribe((res) => {
                this.imagePackageDictionary.update((dict: Record<number, ImagePackage[]>): Record<number, ImagePackage[]> => {
                    return { ...dict, [data.saleId!]: res };
                });
            });

            onCleanup(() => sub.unsubscribe());
        });
    }
    override originalData = computed<ShareSalesDto[]>(() => {
        let mappedSales: ShareSalesDto[] = [];
        let shareSales = this.shareSales();
        if (shareSales) {
            mappedSales = shareSales.map((element) => {
                if (element.hasAdText) {
                    return {
                        ...element,
                        prospectUrl: `${environment.evwebUrl}/reports/prospect?refId=` + element.saleId,
                    };
                }
                return element;
            });
        }
        return mappedSales || [];
    });
    protected isRowExpanded(expanded: boolean, rowData: ShareSalesDto): void {
        if (expanded) {
            this.rowData.set(rowData);
        } else {
            this.rowData.set(null!);
        }
    }
    protected createDisplayTemplate(): ITableLayoutModel {
        return {
            breakPoints: [
                {
                    gridAreas: '"estateType soldDate residentialMeasuredArea floor salesPrice finnAd prospect"',
                    gridColumns: "50px 90px 100px 100px 150px 1fr 150px",
                },
            ],
        };
    }

    protected override createHeaders(): ITableHeader[] {
        return [
            {
                name: "",
                prop: "estateType",
                desc: false,
                type: "text",
                isSortable: false,
            },
            {
                name: "Solgt",
                prop: "soldDate",
                desc: false,
                type: "date",
                isSortable: true,
            },
            {
                name: "m²",
                prop: "residentialMeasuredArea",
                desc: false,
                type: "number",
                isSortable: true,
                textAlignment: "right",
            },
            {
                name: "Etg",
                prop: "floor",
                desc: false,
                type: "number",
                isSortable: true,
                textAlignment: "right",
            },
            {
                name: "Pris",
                prop: "salesPrice",
                desc: false,
                type: "number",
                isSortable: true,
                textAlignment: "right",
            },
            {
                name: "",
                prop: "finnAd",
                desc: false,
                type: "text",
                isSortable: false,
                textAlignment: "right",
            },
            {
                name: "",
                prop: "prospect",
                desc: false,
                type: "text",
                isSortable: false,
                textAlignment: "right",
            },
        ];
    }
}
